import { routePermissions } from "@/constants/permission-user"

export const routesModule4 = [
  {
    path: "/network-configuration/dashboard",
    name: "networkConfigurationDashboard",
    component: () =>
      import("@/views/networkConfigurationManagement/Dashboard.vue"),
    meta: {
      pageTitle: "Dashboard",
      breadcrumb: [
        {
          text: "Dashboard",
          active: true,
        },
      ],
    },
  },
  {
    path: "/network-configuration/node-management",
    name: "networkConfigurationNodeManagement",
    component: () =>
      import("@/views/networkConfigurationManagement/NodeManagement.vue"),
    meta: {
      pageTitle: "Node Management",
      breadcrumb: [
        {
          text: "Node Management",
          active: true,
        },
      ],
    },
  },
  {
    path: "/network-configuration/node-management/:node_id",
    name: "networkConfigurationNodeManagementDetail",
    component: () =>
      import("@/views/networkConfigurationManagement/NodeManagement.vue"),
    meta: {
      pageTitle: "Node Management",
      breadcrumb: [
        {
          text: "Node Management",
          active: true,
        },
      ],
      navActiveLink: "networkConfigurationNodeManagement",
    },
  },
  {
    path: "/network-configuration/configuration-history",
    name: "networkConfigurationConfigurationHistory",
    component: () =>
      import("@/views/networkConfigurationManagement/ConfigurationHistory.vue"),
    meta: {
      pageTitle: "Configuration History",
      breadcrumb: [
        {
          text: "Configuration History",
          active: true,
        },
      ],
    },
  },
  {
    path: "/network-configuration/configuration-template",
    name: "networkConfigurationConfigurationTemplate",
    component: () =>
      import(
        "@/views/networkConfigurationManagement/ConfigurationTemplate.vue"
      ),
    meta: {
      pageTitle: "Configuration Template",
      breadcrumb: [
        {
          text: "Configuration Template",
          active: true,
        },
      ],
    },
  },
  {
    path: "/network-configuration/configuration-template/create-new-template",
    name: "networkConfigurationCreateNewConfigurationTemplate",
    component: () =>
      import(
        "@/views/networkConfigurationManagement/configurationTemplate/CreateEditConfigTemplate.vue"
      ),
    meta: {
      pageTitle: "Create Template",
      breadcrumb: [
        {
          text: "Configuration Template",
          active: false,
          to: "/network-configuration/configuration-template",
        },
        {
          text: "Create New Configuration Template",
          active: true,
        },
      ],
      navActiveLink: "networkConfigurationConfigurationTemplate",
    },
  },
  {
    path: "/network-configuration/configuration-template/:id",
    name: "networkConfigurationConfigurationTemplateDetail",
    component: () =>
      import(
        "@/views/networkConfigurationManagement/configurationTemplate/CreateEditConfigTemplate.vue"
      ),
    meta: {
      pageTitle: "Config Template Detail",
      breadcrumb: [
        {
          text: "Configuration Template",
          active: false,
          to: "/network-configuration/configuration-template",
        },
        {
          text: "Configuration Template Detail",
          active: true,
        },
      ],
      navActiveLink: "networkConfigurationConfigurationTemplate",
    },
  },
  {
    path: "/network-configuration/configuration-template/use-template/:id",
    name: "networkConfigurationUseConfigurationTemplate",
    component: () =>
      import(
        "@/views/networkConfigurationManagement/configurationTemplate/UseConfigTemplate.vue"
      ),
    meta: {
      pageTitle: "Use Template",
      breadcrumb: [
        {
          text: "Configuration Template",
          active: false,
          to: "/network-configuration/configuration-template",
        },
        {
          text: "Use Configuration Template",
          active: true,
        },
      ],
      navActiveLink: "networkConfigurationConfigurationTemplate",
    },
  },
  {
    path: "/network-configuration/configuration-comparison",
    name: "networkConfigurationConfigurationComparison",
    component: () =>
      import(
        "@/views/networkConfigurationManagement/ConfigurationComparison.vue"
      ),
    meta: {
      pageTitle: "Configuration Comparison",
      breadcrumb: [
        {
          text: "Configuration Comparison",
          active: true,
        },
      ],
    },
  },
  {
    path: "/network-configuration/discovery",
    name: "networkConfigurationDiscovery",
    component: () =>
      import("@/views/networkConfigurationManagement/Discovery.vue"),
    meta: {
      pageTitle: "Discovery",
      breadcrumb: [
        {
          text: "Discovery",
          active: true,
        },
      ],
    },
  },
  {
    path: "/network-configuration/credential",
    name: "networkConfigurationCredential",
    component: () =>
      import("@/views/networkConfigurationManagement/Credential.vue"),
    meta: {
      pageTitle: "Credential",
      breadcrumb: [
        {
          text: "Credential",
          active: true,
        },
      ],
    },
  },
  {
    path: "/network-configuration/backup-settings",
    name: "networkConfigurationBackupSettings",
    component: () =>
      import("@/views/networkConfigurationManagement/BackupSettings.vue"),
    meta: {
      pageTitle: "Backup Settings",
      breadcrumb: [
        {
          text: "Backup Settings",
          active: true,
        },
      ],
    },
  },
  {
    path: "/network-configuration/backup-settings/create-new-commands",
    name: "networkConfigurationBackupSettingsCreateNewCommands",
    component: () =>
      import(
        "@/views/networkConfigurationManagement/backupSettings/CreateEditCommands.vue"
      ),
    meta: {
      pageTitle: "Create New Commands",
      breadcrumb: [
        {
          text: "Backup Settings",
          active: false,
          to: "/network-configuration/backup-settings",
        },
        {
          text: "Create New Commands",
          active: true,
        },
      ],
      navActiveLink: "networkConfigurationBackupSettings",
    },
  },
  {
    path: "/network-configuration/backup-settings/:id",
    name: "networkConfigurationBackupSettingsDetail",
    component: () =>
      import(
        "@/views/networkConfigurationManagement/backupSettings/CreateEditCommands.vue"
      ),
    meta: {
      pageTitle: "Backup Command Detail",
      breadcrumb: [
        {
          text: "Backup Settings",
          active: false,
          to: "/network-configuration/backup-settings",
        },
        {
          text: "Backup Command Detail",
          active: true,
        },
      ],
      navActiveLink: "networkConfigurationBackupSettings",
    },
  },
].map((route) => {
  return {
    ...route,
    meta: {
      ...route.meta,
      module: "networkConfiguration",
      type: "internal",
      permission: routePermissions[route.name],
    },
  }
})
